import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class UserCountryService {

    private readonly STORAGE_KEY = 'fcUserCountryCode';
    private readonly DEFAULT_COUNTRY_CODE = 'BR';
    // private readonly API_URL = 'http://ip-api.com/json/?fields=status,countryCode,message&noLoader=true';
    private readonly API_URL = 'https://ipinfo.io/json?token=50fd1f2e6a9750&noLoader=true';

    constructor(private http: HttpClient) {}

    // ipinfo.io
    getUserCountryCode(): Observable<string> {

        const cachedCode = localStorage.getItem(this.STORAGE_KEY);

        if (cachedCode && /^[A-Z]{2}$/.test(cachedCode)) {
            return of(cachedCode.toUpperCase());
        }

        return this.http.get<any>(this.API_URL).pipe(
            map((data) => {
                if (data && data.country && /^[A-Z]{2}$/.test(data.country)) {
                    const countryCode = data.country.toUpperCase();
                    localStorage.setItem(this.STORAGE_KEY, countryCode);
                    return countryCode;
                } else {
                    return this.DEFAULT_COUNTRY_CODE;
                }
            }),
            catchError(() => of(this.DEFAULT_COUNTRY_CODE))
        );
    }

    // ip-api.com
    // getUserCountryCode(): Observable<string> {
    //
    //     const cachedCode = localStorage.getItem(this.STORAGE_KEY);
    //
    //     if (cachedCode && /^[A-Z]{2}$/.test(cachedCode)) {
    //         return of(cachedCode.toUpperCase());
    //     }
    //
    //     return this.http.get<any>(this.API_URL).pipe(
    //         map((data) => {
    //             if (data.status === 'success' && /^[A-Z]{2}$/.test(data.countryCode)) {
    //                 localStorage.setItem(this.STORAGE_KEY, data.countryCode.toUpperCase());
    //                 return data.countryCode.toUpperCase();
    //             } else {
    //                 return this.DEFAULT_COUNTRY_CODE;
    //             }
    //         }),
    //         catchError(() => {
    //             return of(this.DEFAULT_COUNTRY_CODE);
    //         })
    //     );
    // }
}
